const actions = {
	SET_MANAGE_REDIRECT_IS_OPEN: 'SET_MANAGE_REDIRECT_IS_OPEN',

	setOpen: (
		url: string | null = null,
		featureAvailableInManage: boolean = true,
	) => ({
		type: actions.SET_MANAGE_REDIRECT_IS_OPEN,
		url,
		featureAvailableInManage,
	}),
};

export default actions;
